<div class="content">
  <div class="content__inputs">
    <qr-date-picker
      class="content__from"
      [config]="datePickerFrom"
      (datepickerChange)="datepickerFromChange($event)"
    ></qr-date-picker>
    <qr-date-picker
      class="content__to"
      [config]="datePickerTo"
      (datepickerChange)="datepickerToChange($event)"
    ></qr-date-picker>
  </div>
  <p class="content__error">{{ msgError }}</p>
</div>
